import React from 'react';
import { Route } from '../Routing/types';
import {
  BuyIndexPage,
  BuyAddPage,
  BuyLoginPage,
  BuySignUpPage,
  BuyThankYouPage,
} from '@front-activerse/modules';
import {
  PATH_BUY,
  PATH_BUY_SIGNUP,
  PATH_BUY_LOGIN,
  PATH_BUY_ADD,
  PATH_BUY_THANK_YOU,
} from './paths';
import { externalWebView } from '@front-activerse/common-components';

const isExternamWebView = externalWebView();

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: PATH_BUY,
    element: <BuyIndexPage />,
    private: true,
    title: dummy_t('buy.navbarTitle'),
  },
  {
    path: PATH_BUY_SIGNUP,
    element: (
      <BuySignUpPage
        displayGoogleButton={isExternamWebView ? false : true}
        displayFacebookButton={false}
        loginButtonURL={PATH_BUY_LOGIN}
        redirectToPathAfterSuccessFromRoute={PATH_BUY}
        action="stripe" // stripe register
      />
    ),
    private: false,
    title: dummy_t('buy.navbarTitle'),
  },
  {
    path: PATH_BUY_LOGIN,
    element: (
      <BuyLoginPage
        displayGoogleButton={isExternamWebView ? false : true}
        displayFacebookButton={false}
        registerButtonURL={PATH_BUY_SIGNUP}
        redirectToPathAfterSuccessFromRoute={PATH_BUY}
        action="stripe_login"
      />
    ),
    private: false,
    title: dummy_t('buy.navbarTitle'),
  },
  {
    path: PATH_BUY_ADD,
    element: <BuyAddPage pathBuySignup={PATH_BUY_SIGNUP} />,
    private: false,
    title: dummy_t('buy.navbarTitle'),
  },
  {
    path: PATH_BUY_THANK_YOU,
    element: <BuyThankYouPage />,
    private: false,
    title: dummy_t('buy.navbarTitle'),
  },
];

export default routes;
